import { AnimatePresence, motion } from "framer-motion";
import { X, LogOut, AlertCircle, Bell, Bookmark, ChartAreaIcon, FileCheck, FileText, Home, MessageCircle, Settings, Settings2, Shield, User, User2, UserSearch, Wallet, Lock, UserSearchIcon, StarIcon } from "lucide-react";
import React, { useState } from "react";
import { LogoutManually, LogoutUser, useAppDispatch } from "../../../redux";
import { Link } from "react-router-dom";
import { MdReviews } from "react-icons/md";
import SocialMediaLinks from "../../../components/ui/SocialMediaLinks";

const SidebarComponent = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const dispatch = useAppDispatch();
    const headerNavItems = [
        // Currently empty as per original code
    ];
    const sidebarItems = [
        { icon: <Home className="h-5 w-5" />, label: "Dashboard", href: "/professionals", active: true },
        { icon: <UserSearchIcon className="h-5 w-5" />, label: "Local Customers", href: "/professional" },
        { icon: <Bookmark className="h-5 w-5" />, label: "International Clients", href: "/international-professionals" },
        { icon: <MessageCircle className="h-5 w-5" />, label: "Message or Video Call", href: "/MessageAndVideoCall" },
        { icon: <User2 className="h-5 w-5" />, label: "My Profile", href: "/professionals/myprofile" },
        // { icon: <Settings2 className="h-5 w-5" />, label: "My Settings", href: "/professionals/settings" },
        { icon: <ChartAreaIcon className="h-5 w-5" />, label: "Progress", href: "/Progress" },
        { icon: <FileCheck className="h-5 w-5" />, label: "My Orders", href: "/myorders" },
        { icon: <MdReviews className="h-5 w-5" />, label: "Reviews", href: "/professional/reviews" },
        { icon: <Bell className="h-5 w-5" />, label: "My Offers", href: "/myoffers" },
        { icon: <FileText className="h-5 w-5" />, label: "My Proposals - Whatsapp", href: "/myproposals" },
        { icon: <Shield className="h-5 w-5" />, label: "Support tickets", href: "/support" },
        { icon: <Wallet className="h-5 w-5" />, label: "Wallet", href: "/wallet" },
        { icon: <StarIcon className="h-5 w-5" />, label: "Favorites", href: "/professional/favorites" },
        // { icon: <Wallet className="h-5 w-5" />, label: "Report", href: "/client/reports" },
        { icon: <FileText className="h-5 w-5" />, label: "Withdraw History", href: "/withdrawalhistroy" },
        { icon: <FileCheck className="h-5 w-5" />, label: "Subscriptions", href: "/credits" },
        { icon: <Lock className="h-5 w-5" />, label: "Change Password", href: "/changepassword" },
        { icon: <AlertCircle className="h-5 w-5" />, label: "Account Delete", href: "/DeleteAccount" },
        { icon: <LogOut className="h-5 w-5" />, label: "Log Out", href: "/logout" }
    ];

    const StoreLinks = () => (
        <div className="flex justify-center gap-2 pt-6 px-4">
            <a
                href="https://play.google.com/store/apps/details?id=com.kokobeo"
                className="w-1/2"
            >
                <img
                    src="https://texttofloss.com/wp-content/uploads/2021/01/Google-Play-Store-Button.png"
                    alt="Get it on Google Play"
                    className="w-full h-auto rounded-md hover:opacity-90 transition-opacity"
                    style={{ maxWidth: "160px", height: "50px", objectFit: "contain" }}
                />
            </a>
            <a href="https://apps.apple.com/app/kokobeo" className="w-1/2">
                <img
                    src="https://e7.pngegg.com/pngimages/422/842/png-clipart-apple-store-logo-app-store-android-google-play-get-started-now-button-text-logo.png"
                    alt="Download on App Store"
                    className="w-full h-auto rounded-md hover:opacity-90 transition-opacity"
                    style={{ maxWidth: "160px", height: "50px", objectFit: "contain" }}
                />
            </a>
        </div>
    );

    const SocialIcons = () => (
        <SocialMediaLinks containerSize="w-7 h-7"  className="flex justify-center space-x-4 pt-4 px-4 pb-6" iconSize="h-4 w-4" />
    );

    const handleLogout = async () => {
        try {
            const response = await dispatch(LogoutUser({})).unwrap();
        } catch (error: any) {
            if (error === 401) {
                dispatch(LogoutManually());
                console.log("Token expired");
            } else {
                console.log("Logout failed:", error);
            }
        }
    };
    return (
        <>
            <aside className="hidden lg:block fixed left-0 top-16 bottom-0 w-64 bg-white border-r overflow-y-auto h-[calc(100vh-64px)]">
                <nav className="p-4 space-y-1 h-full flex flex-col">
                    <div className="flex-1 overflow-y-auto">
                        {sidebarItems.map((item, index) => item.href === "/logout" ?
                            <button
                                key={index}
                                onClick={handleLogout}
                                className="flex w-full items-center gap-2 px-3 py-2 rounded-lg text-sm transition-colors text-gray-600 hover:bg-gray-50">
                                {item.icon}
                                <span>{item.label}</span>
                            </button> : (
                                <Link
                                    key={index}
                                    to={item.href}
                                    className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm transition-colors ${item.active ? "text-blue-600 bg-blue-50 font-medium" : "text-gray-600 hover:bg-gray-50"
                                        }`}
                                >
                                    {item.icon}
                                    <span>{item.label}</span>
                                </Link>
                            ))}
                    </div>
                    <div className="mt-auto w-full">
                        <StoreLinks />
                        <SocialIcons />
                    </div>
                </nav>
            </aside>

            {/* Mobile Sidebar - Slide-in, Independent Scroll, Full Width */}
            <AnimatePresence>
                {isMobileMenuOpen && (
                    <>
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            onClick={() => setIsMobileMenuOpen(false)}
                            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40 lg:hidden"
                        />
                        <motion.aside
                            initial={{ x: "-100%" }}
                            animate={{ x: 0 }}
                            exit={{ x: "-100%" }}
                            transition={{ type: "spring", bounce: 0, duration: 0.4 }}
                            className="fixed inset-y-0 left-0 w-full max-w-xs bg-white shadow-xl z-50 lg:hidden flex flex-col"
                            style={{ top: "64px", height: "calc(100% - 64px)" }}
                        >
                            <div className="flex items-center justify-between p-4 border-b">
                                <div className="flex items-center gap-3">
                                    <img src="https://assests.netlify.app/assets/images/logo.png" alt="Logo" className="h-8 w-8" />
                                    <span className="text-blue-600 text-lg font-bold">Kokobeo</span>
                                </div>
                                <button
                                    onClick={() => setIsMobileMenuOpen(false)}
                                    className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
                                >
                                    <X className="h-6 w-6" />
                                </button>
                            </div>

                            {/* Scrollable menu items */}
                            <div className="flex-1 overflow-y-auto">
                                <nav className="p-4">
                                    {sidebarItems.map((item, index) => item.href === "/logout" ?
                                        <button
                                            key={index}
                                            onClick={handleLogout}
                                            className="flex w-full items-center gap-2 px-3 py-2 rounded-lg text-sm transition-colors text-gray-600 hover:bg-gray-50">
                                            {item.icon}
                                            <span>{item.label}</span>
                                        </button> : (
                                            <Link
                                                key={index}
                                                to={item.href}
                                                className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm transition-colors mb-1 ${item.active ? "text-blue-600 bg-blue-50 font-medium" : "text-gray-600 hover:bg-gray-50"
                                                    }`}
                                                onClick={() => setIsMobileMenuOpen(false)}
                                            >
                                                {item.icon}
                                                <span>{item.label}</span>
                                            </Link>
                                        ))}
                                </nav>
                            </div>

                            {/* Fixed bottom section */}
                            <div className="p-4 border-t bg-white">
                                <StoreLinks />
                                <SocialIcons />
                            </div>
                        </motion.aside>
                    </>
                )}
            </AnimatePresence>
        </>
    );
};

export default SidebarComponent;